<label class="top-label field-label" [for]="valueControlName">
    {{ fieldLabel | translate }}<span class="required-label text-danger" *ngIf="isRequired">*</span>
    <span class="walkme-anchor" [attr.walkme-anchor]="fieldLabel"></span>
</label>
<div class="dual-inputs">
    <!-- absolute amount (e.g. gal) -->
    <app-form-field class="value-half"
                    [formGroup]="formGroup"
                    [hideLabel]="true"
                    [forceInvalid]="pairInvalid"
                    [fieldId]="valueControlName"
                    [fieldControlName]="valueControlName"
                    type="number"
                    [isRequired]="isRequired"
                    [appearance]="appearance"
                    [suffix]="valueSuffix"
                    [formState]="valueFormState"
                    [validatorOrOpts]="valueValidators"
                    [warningText]="warningText"
                    [tabIndex]="tabIndex"
                    (input)="onValueEdited()"></app-form-field>

    <!-- the same quantity as a percentage of baseValue -->
    <app-form-field class="percent-half"
                    [formGroup]="formGroup"
                    [hideLabel]="true"
                    [forceInvalid]="pairInvalid"
                    [fieldId]="percentControlName"
                    [fieldControlName]="percentControlName"
                    type="number"
                    [isRequired]="isRequired"
                    [appearance]="appearance"
                    [suffix]="percentSuffix"
                    [formState]="percentFormState"
                    [validatorOrOpts]="percentValidators"
                    [tabIndex]="percentTabIndex"
                    (input)="onPercentEdited()"></app-form-field>
</div>
